/** @format */
import { Component, Input } from '@angular/core';

@Component({
    selector: 'product-reviews-review-badges',
    templateUrl: './review-badges.component.html',
    styleUrls: ['./review-badges.component.scss'],
    standalone: false
})
export class ReviewBadgesComponent {
	@Input() badgeType: string;
}